<template>
    <div>
        <div v-if="stayReminderModal">
            <StayOnPageReminder @confirm="handleModalConfirm" @cancel="handleModalCancel" />
        </div>

        <div v-if="toast" class="onboarding-toast">
            <div :class="{ 'success': !onboardingError, 'error': onboardingError }">{{ toastValue }}</div>
        </div>
        <div class="container-onboard-payout">

            <div class="flex-item">
                <OnboardingPayoutForm />

            </div>
            <div class="flex-item flex-item-2">

                <GovernmentDocForm />

            </div>
        </div>
        <div class="footer-btn">
            <b-button @click="setReminder" class="cancel-btn">Cancel</b-button>
            <b-button @click="submitForm" class="save-btn"><span v-if="!loading1">Save</span> <span v-if="loading1"><img
                        class="spinner" src="@/assets/images/onboarding/loading.svg" alt="loading"></span></b-button>
        </div>

    </div>
</template>
<script>
import onboarding from "@/services/onboarding";
import { mapState, mapActions, mapGetters } from "vuex";
import OnboardingPayoutForm from "@/components/onboarding/OnboardingPayoutForm";
import GovernmentDocForm from "@/components/onboarding/GovernmentDocForm";
import StayOnPageReminder from "@/components/onboarding/StayOnPageReminder";

export default {

    name: "OnboardPage",
    components: {
        OnboardingPayoutForm,
        GovernmentDocForm,
        StayOnPageReminder
    },
    beforeRouteLeave(to, from, next) {

        if (!this.isSave) {
            this.$store.commit('onboarding/setStayReminderModal', true);

            this.$once('modalConfirmed', () => {
                next();
            });

            this.$once('modalCancelled', () => {
                next(false);
            });
        }
        else {
            next();
        }

    },
    data() {
        return {
            data: null,
            isSave: false
        };
    },
    computed: {
        ...mapState("onboarding", {
            formBankDetails: state => state.formBankDetails,
            base64String: state => state.base64String,
            toast: state => state.toast,
            toastValue: state => state.toastValue,
            onboardingError: state => state.onboardingError,
            loading1: state => state.loading1,
            stayReminderModal: state => state.stayReminderModal,
            bankDetails: state => state.bankDetails

        }),
    },
    methods: {
        ...mapActions("onboarding", [
            "getPayoutDetails",
            "updatePayoutDetails",
            "getMerchantSetup",
            "getProvinces",
            "getCities",
            "getBranchList",
            "getWebList",
            "getFulfillment",
            "getFulfillmentFees",
            "getPayoutDetails",
            "getFulfillmentSetupList",
            "updateFulfillment",
            "saveFulfillmentFeesSettings"
        ]),
        handleModalConfirm() {
            this.$store.commit('onboarding/setStayReminderModal', false);
            this.$store.commit('onboarding/setPayoutRequirementsBack', true);
            this.$emit('modalConfirmed'); // Emit event to handle navigation
        },
        handleModalCancel() {
            this.$store.commit('onboarding/setStayReminderModal', false);
            this.$emit('modalCancelled'); // Emit event to handle navigation
        },
        resetFormErrors() {
            this.$store.commit('onboarding/setBankValidEmail', false)
            this.$store.commit('onboarding/setMinimumNumberError', false)
            this.$store.commit('onboarding/setMinimumAccountNumberError', false)
            this.$store.commit('onboarding/setBankRequirementsFormErrors', false)
            this.$store.commit('onboarding/setProofOfBankingError', false)
            this.$store.commit('onboarding/setGovernmentIdError', false)
            this.$store.commit('onboarding/setOtherGovenmentDocuError', false)
            this.$store.commit('onboarding/setPayoutRequirementsContactNumberInvalid', false)
            this.$store.commit('onboarding/setMinimumNumberError', false)
        },
        checkFormIsEmpty() {
            const regex = /^9\d{9}$/;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            let formData = {}
            if (this.formBankDetails.merchantName === '' || this.formBankDetails.merchantName === null) {
                formData.name = "empty"
            }
            if (this.formBankDetails.businessAddress === '' || this.formBankDetails.businessAddress === null) {
                formData.address = "empty"
            }
            if (this.formBankDetails.contactNumber === '' || this.formBankDetails.contactNumber === null) {
                formData.mobile_number = "empty"
            }
            if (this.formBankDetails.emailAddress === '' || this.formBankDetails.emailAddress === null) {
                formData.email_address = "empty"
            }
            if (this.formBankDetails.tin_number === '' || this.formBankDetails.tin_number === null) {
                formData.tin_number = "empty"
            }
            if (this.formBankDetails.bankName === '' || this.formBankDetails.bankName === null) {
                formData.bank_name = "empty"
            }
            if (this.formBankDetails.bankAddress === '' || this.formBankDetails.bankAddress === null) {
                formData.bank_address = "empty"
            }
            if (this.formBankDetails.accountNumber === '' || this.formBankDetails.accountNumber === null) {
                formData.bank_account_number = "empty"
            }
            if (this.formBankDetails.accountName === '' || this.formBankDetails.accountName === null) {
                formData.bank_account_name = "empty"
            }
            if (this.formBankDetails.bankSwiftCode === '' || this.formBankDetails.bankSwiftCode === null) {
                formData.bank_swift_code = "empty"
            }
            if (this.formBankDetails.contactNumber !== '' && this.formBankDetails.contactNumber !== null && this.formBankDetails.contactNumber.length < 10 || this.formBankDetails.contactNumber.length > 10 || this.formBankDetails.contactNumber.length < 0) {
                this.$store.commit('onboarding/setPayoutRequirementsContactNumberInvalid', true)
                formData.invalidContactNumber = "empty"
            }
            if (this.formBankDetails.contactNumber !== '' && this.formBankDetails.contactNumber !== null && !regex.test(this.formBankDetails.contactNumber)) {
                this.$store.commit('onboarding/setPayoutRequirementsContactNumberInvalid', true)
                formData.invalidContactNumber = "empty"
            }

            if (this.formBankDetails.emailAddress !== '' && this.formBankDetails.emailAddress !== null) {
                if (!emailRegex.test(this.formBankDetails.emailAddress)) {
                    this.$store.commit('onboarding/setBankValidEmail', true)
                    formData.regex = "empty"
                    console.log("asdfsd")
                }

            }
            if (this.formBankDetails.tin_number !== '' && this.formBankDetails.tin_number !== null) {
                if (this.formBankDetails.tin_number.length < 9 || this.formBankDetails.tin_number.length > 12) {
                    this.$store.commit('onboarding/setMinimumNumberError', true)
                    formData.minTin = "empty"
                }
            }
            if (this.formBankDetails.accountNumber !== null && this.formBankDetails.accountNumber !== '') {
                if (this.formBankDetails.accountNumber.length < 10 || this.formBankDetails.accountNumber.length > 30) {
                    this.$store.commit('onboarding/setMinimumAccountNumberError', true)
                    formData.minAccount = "empty"
                }
            }
            this.$store.commit('onboarding/setBankRequirementsFormErrors', formData)

            return Object.keys(formData).length === 0;
        },
        validateExistFile() {
            let existGovId = false;
            let existOtherDocu = false;
            let existBankingProof = false;
            if (this.bankDetails.documents.length !== 0) {
                this.bankDetails.documents.forEach(obj => {
                    if (obj.type === 'government_id') {
                        if (obj.link !== null) {
                            existGovId = true;
                        }
                    }
                    if (obj.type === 'other_government_docu') {
                        if (obj.link !== null) {
                            existOtherDocu = true;
                        }
                    }
                    if (obj.type === 'banking_proof') {
                        if (obj.link !== null) {
                            existBankingProof = true
                        }
                    }
                })

                return existGovId && existOtherDocu && existBankingProof

            }

            return false

        },
        async formValidation(data) {

            const isFormEmpty = this.checkFormIsEmpty()
            let newData = null

            if (data.hasOwnProperty("documents")) {
                const hasGoveId = this.base64String.some(
                    (obj) => obj.type === "government_id"
                );
                const hasProofOfBanking = this.base64String.some(
                    (obj) => obj.type === "banking_proof"
                );
                const hasOtherGoveDoc = this.base64String.some(
                    (obj) => obj.type === "other_government_docu"
                );

                if (hasGoveId && hasProofOfBanking && hasOtherGoveDoc) {
                    if (isFormEmpty) {
                        await this.updatePayoutDetails({ payload: data })
                    }
                }

                else {
                    this.$store.commit('onboarding/setProofOfBankingError', !hasProofOfBanking)
                    this.$store.commit('onboarding/setGovernmentIdError', !hasGoveId)
                    this.$store.commit('onboarding/setOtherGovenmentDocuError', !hasOtherGoveDoc)
                }
            }
            else {
                if (this.base64String.length !== 0) {
                    newData = data
                    newData.documents = this.base64String
                    if (isFormEmpty) {
                        await this.updatePayoutDetails({ payload: newData })
                    }

                }
                else {
                    if (isFormEmpty) {
                        await this.updatePayoutDetails({ payload: data })
                    }

                }

            }


        },
        async submitForm() {
            this.isSave = true
            // this.$store.commit('onboarding/setBankRequirementsFormErrors', false)
            this.resetFormErrors()
            const data = {
                "name": this.formBankDetails.merchantName,
                "address": this.formBankDetails.businessAddress,
                "mobile_number": this.formBankDetails.contactNumber,
                "email_address": this.formBankDetails.emailAddress,
                "tin_number": this.formBankDetails.tin_number,
                "bank_name": this.formBankDetails.bankName,
                "bank_address": this.formBankDetails.bankAddress,
                "bank_account_currency": this.formBankDetails.currency,
                "bank_account_number": this.formBankDetails.accountNumber,
                "bank_account_name": this.formBankDetails.accountName,
                "bank_swift_code": this.formBankDetails.bankSwiftCode,
                "documents": this.base64String
            }
            if (this.validateExistFile()) {
                delete data.documents
            }
            this.data = data
            await this.formValidation(this.data)
            await this.getMerchantSetup()

        },
        setReminder() {
            this.$router.go(-1)
        },


    },
    async mounted() {
        await this.$store.commit('onboarding/setBase64String', [])
        await this.$store.commit('onboarding/setBankRequirementsFormErrors', false)
        await this.$store.commit('onboarding/setPayoutRequirementsBack', false)
        await this.$store.commit('onboarding/setStayReminderModal', false)
        await this.$store.commit('onboarding/setBankValidEmail', false)
        await this.resetFormErrors()
        await this.$store.commit('onboarding/setLogisticError', false)
        await this.getPayoutDetails()
    }
}

</script>
<style lang="scss" scoped>
.spinner {
    animation: rotate 1.5s linear infinite;
    /* Add rotation animation */
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
        /* Start rotation from 0 degrees */
    }

    to {
        transform: rotate(360deg);
        /* Rotate 360 degrees (full circle) */
    }
}

.onboarding-toast {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 132px;
    padding: 0px 10px;
    height: 29px;
    position: fixed;
    left: 55%;
    transform: translate(-50%, -50%);
    border-radius: 38px;
    border: 1px solid #E9EBED;
    background: #FFF;
    box-shadow: 0px 2px 5px -3px rgba(67, 67, 67, 0.25);
    z-index: 99999;

    .success {
        color: #139961;
        font-family: MainFontRegular, sans-serif;
        font-size: 13px;
        font-style: normal;
        line-height: normal;

    }

    .error {
        color: red;
        font-family: MainFontRegular, sans-serif;
        font-size: 13px;
        font-style: normal;
        line-height: normal;
    }
}

.footer-btn {
    display: flex;
    background-color: #fff;
    height: 69.167px;
    justify-content: end;
    padding: 15px;
    border: 1px solid #E9EBED;

    .cancel-btn {
        display: inline-flex;
        height: 45px;
        padding: 15px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1.5px solid #87929D;
        background: white;
        color: #68737D;
    }

    .save-btn {
        margin-left: 10px;
        margin-right: 93px;
        border: none;
        height: 45px;
        border-radius: 8px;
        background: #53B6B2;
        display: flex;
        width: 116px;
        padding: 15px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;

        @media(max-width: 868px) {
            margin-right: 20px;
        }

        @media(max-width: 350px) {
            margin-right: 10px;
        }
    }

}

.container-onboard-payout {
    display: flex;
    padding: 50px 24px 50px 0px;
    width: 100%;

    @media (max-width: 1102px) {
        flex-direction: column;
        padding: 50px 0px;
    }


    .flex-item:first-child {
        flex: 1;
        padding-left: 24px;

        @media (max-width: 1102px) {
            padding: 0px;
        }
    }


    .flex-item {
        display: flex;
        justify-content: center;
        font-family: MainFontRegular, sans-serif;
        font-style: normal;
        line-height: normal;
    }

    .flex-item:last-child {
        flex: 1;
    }

    .flex-item-2 {
        height: min-content;
    }

}
</style>
